import { DataType } from "@sdbn/common";
import { v4 as uuidv4 } from 'uuid';

export class EquipmentType {

  id: string;

  name: string;
  description: string;
  manageInstances: boolean;
  requiresTakeback: boolean;
  disabled: boolean;
  systemType: boolean;
  systemTypeIdentifier: string;

  attributeDefinition: string;

  equipments = new Array<Equipment>();

  constructor(type?: Partial<EquipmentType>) {
    if (type != null) {
      this.id = type.id;
      this.name = type.name;
      this.description = type.description;
      this.manageInstances = type.manageInstances || false;
      this.requiresTakeback = type.requiresTakeback || false;
      this.disabled = type.disabled || false;
      this.systemType = type.systemType || false;
      this.systemTypeIdentifier = type.systemTypeIdentifier;
      this.attributeDefinition = type.attributeDefinition;
      if (type.equipments != null) {
        for (const equipment of type.equipments) {
          this.equipments.push(new Equipment(equipment));
        }
      }
    }
  }

}

export class EquipmentTypeAttribute {

  id: string;

  name: string;
  description: string;
  type: DataType;
  required: boolean;
  systemType: boolean;
  systemTypeIdentifier: string;

}

export class Equipment {

  id: string;
  identifier: string;
  disabled: boolean;
  values = new Array<EquipmentAttributeValue>();

  constructor(equippment: Partial<Equipment>) {
    if (equippment != null) {
      this.id = equippment.id || uuidv4();
      this.identifier = equippment.identifier;
      this.disabled = equippment.disabled;
      if (equippment.values != null) {
        for (const value of equippment.values) {
          this.values.push(new EquipmentAttributeValue(value));
        }
      }
    }
  }

}

export class EquipmentAttributeValue {

  id: string;

  key: string;
  value: string;

  constructor(value?: Partial<EquipmentAttributeValue>) {
    if (value != null) {
      this.id = value.id;
      this.key = value.key;
      this.value = value.value;
    }
  }

}

export class EquipmentUsage {

  id: string;

  equipmentTypeId: string;
  equipmentId: string;
  targetObject: string;
  targetObjectId: string;
  hint: string;
  handout: string;
  takeBack: string;
  handedOut: boolean;

}
